import { render, staticRenderFns } from "./ThirdPartQrCode.vue?vue&type=template&id=f0d22880&scoped=true&"
import script from "./ThirdPartQrCode.vue?vue&type=script&lang=js&"
export * from "./ThirdPartQrCode.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartQrCode.vue?vue&type=style&index=0&id=f0d22880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d22880",
  null
  
)

export default component.exports